/** @format */

import axios from 'axios'

import { notification } from 'antd'

import { ENV_FUNCTION_USER } from '../../enviroment'
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant'


export default async function serviceFindUser(token) {
	return await axios({
		method: 'GET',
		url: `${Enviroment.API_PHARMACY}/user-panel/get-me`,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((response) => {
			console.log('responseUser',response)
			if (response.data.statusCode === 200) {
				return response.data.data
			} else {
				notification['error']({
					message: response.data.error,
					description: response.data.message,
				})
				return { ...response.data, error: true }
			}
		})
		.catch((error) => {
			notification['error']({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_USER}/user/find-user`,
			})
		})
}
